import { useCallback, useEffect, useRef, useState } from "react";

export function useRevealAnimation() {
  const mountedRef = useRef(true);
  const [isRevealing, setIsRevealing] = useState(false);
  const [revealedRound, setRevealedRound] = useState(null);

  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const resetReveal = useCallback(() => {
    setIsRevealing(false);
    setRevealedRound(null);
  }, []);

  const finishReveal = useCallback((round) => {
    if (!mountedRef.current) return;
    setRevealedRound(round || null);
    setIsRevealing(false);
  }, []);

  const runReveal = useCallback(async (action) => {
    setRevealedRound(null);
    setIsRevealing(true);

    try {
      const round = await action();
      if (mountedRef.current) {
        setRevealedRound(round || null);
        setIsRevealing(false);
      }
      return round;
    } catch (error) {
      if (mountedRef.current) {
        setIsRevealing(false);
        setRevealedRound(null);
      }
      throw error;
    }
  }, []);

  return { isRevealing, revealedRound, resetReveal, finishReveal, runReveal };
}

export default useRevealAnimation;
